<template>
  <div class="review-content">
    <BoardSearch
      :placeholder="searchPlaceholder"
      v-model="searchKeyword"
      @search="handleSearch"
    />

    <div class="review-grid">
      <ReviewCard
        v-for="review in reviews"
        :key="review.id"
        :review="review"
        @click="handleReviewClick"
      />
    </div>

    <!-- 초기 로딩 중일 때 표시 -->
    <LoadingSpinner
      v-if="loading && reviews.length === 0"
      text="리뷰를 불러오는 중입니다..."
      size="medium"
      container="inline"
    />

    <!-- 검색 결과 없음 -->
    <div v-if="!loading && reviews.length === 0" class="empty-container">
      <p class="empty-text">검색 결과가 없습니다.</p>
    </div>

    <!-- 더보기 버튼 -->
    <button
      class="btn-more"
      v-if="showMoreButton && !loading"
      @click="handleLoadMore"
    >
      더보기
    </button>

    <!-- 더보기 로딩 -->
    <div v-if="loading && reviews.length > 0" class="more-loading">
      <LoadingSpinner
        text="추가 리뷰를 불러오는 중..."
        size="small"
        container="inline"
      />
    </div>
  </div>
</template>

<script>
import BoardSearch from "./BoardSearch.vue";
import ReviewCard from "./ReviewCard.vue";
import LoadingSpinner from "./LoadingSpinner.vue";

export default {
  name: 'ReviewList',
  components: {
    BoardSearch,
    ReviewCard,
    LoadingSpinner
  },
  props: {
    reviews: {
      type: Array,
      required: true,
      default: () => []
    },
    searchPlaceholder: {
      type: String,
      default: '검색어를 입력하세요'
    },
    showMoreButton: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchKeyword: ''
    };
  },
  methods: {
    handleSearch(keyword) {
      this.$emit('search', keyword);
    },
    handleReviewClick(id) {
      this.$emit('review-click', id);
    },
    handleLoadMore() {
      this.$emit('load-more');
    }
  }
};
</script>

<style scoped lang="scss">
.review-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 38px 100px;
}

.review-grid {
  margin-top: 32px;
  display: grid;
  //grid-template-columns: repeat(3, 1fr);
  gap: 40px 30px;
}

.btn-more {
  margin-top: 66px;
  font-size: 23.55px;
  line-height: 69.25px;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #222;
  width: 100%;
  cursor: pointer;
  background: white;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #f5f5f5;
  }
}

.empty-container {
  text-align: center;
  padding: 80px 20px;
}

.empty-text {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
}

.more-loading {
  margin-top: 40px;
  padding: 20px;
}

// =========================================================================
// 모바일 반응형 (768px 이하)
// =========================================================================
@media (max-width: 768px) {
  .review-content {
    padding: 40px 20px 60px;
  }

  .review-grid {
    gap: 24px 16px;
  }

  .btn-more {
    margin-top: 40px;
    font-size: 18px;
    line-height: 52px;
    min-height: 48px;
  }

  .empty-container {
    padding: 60px 20px;
  }

  .empty-text {
    font-size: 16px;
  }

  .more-loading {
    margin-top: 30px;
    padding: 16px;
  }
}
</style>
